import type { SupportedCountry } from "@config";
import { BaseCountryAdapter } from "./base";
import type { MapSearchType } from "@repo/maps";
import type { CurrencyType } from "@repo/database";

export class NewZealandAdapter extends BaseCountryAdapter {
  code: SupportedCountry = "nz";
  currency: CurrencyType = "NZD";
  areaMeasurementUnit = "metric" as const;

  isZipCode(input: string): boolean {
    return /^\d{4}$/.test(input.trim());
  }

  getLocationTypesForSegments(segments: string[]): MapSearchType[] | undefined {
    if (segments.length === 0) {
      return undefined;
    }

    switch (segments.length) {
      case 1:
        return ["region"];
      case 2:
        return ["district", "place", "neighborhood"];
      case 3:
        return ["place", "neighborhood"];
      default:
        return ["place", "neighborhood"];
    }
  }
}

export const nz = new NewZealandAdapter();
